export default __webpack_public_path__ + "static/media/d52.1798ddd6.png";